const slugifyPolicyHeading = (value) => value
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9\s-]/g, '')
  .replace(/\s+/g, '-')
  .replace(/-+/g, '-');

const makePolicyLinks = (headings) => {
  const links = document.createElement('nav');
  links.className = 'berara-native-policy__toc-links';
  links.setAttribute('aria-label', 'Policy contents');

  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = slugifyPolicyHeading(heading.textContent) || `policy-section-${index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    links.append(link);
  });

  return links;
};

const initialiseBeraraPolicy = () => {
  const container = document.querySelector('.shopify-policy__container');
  const title = container?.querySelector('.shopify-policy__title');
  const body = container?.querySelector('.shopify-policy__body');
  if (!container || !title || !body || container.dataset.beraraReady === 'true') return;

  container.dataset.beraraReady = 'true';
  const path = window.location.pathname;
  const titleByRoute = path.includes('/shipping-policy')
    ? document.body.dataset.beraraPolicyShippingTitle
    : path.includes('/refund-policy')
      ? document.body.dataset.beraraPolicyRefundTitle
      : path.includes('/privacy-policy')
        ? document.body.dataset.beraraPolicyPrivacyTitle
        : path.includes('/terms-of-service')
          ? document.body.dataset.beraraPolicyTermsTitle
          : '';
  const heading = title.querySelector('h1');
  if (heading && titleByRoute) heading.textContent = titleByRoute;
  const pageTitle = title.textContent.trim();
  const tocLabel = document.body.dataset.beraraPolicyTocLabel || 'On this page';

  const hero = document.createElement('header');
  hero.className = 'berara-native-policy__hero';

  const breadcrumbs = document.createElement('nav');
  breadcrumbs.className = 'berara-native-policy__breadcrumbs';
  breadcrumbs.setAttribute('aria-label', 'Breadcrumb');
  const homeLink = document.createElement('a');
  homeLink.href = document.body.dataset.beraraRootUrl;
  homeLink.textContent = 'Home';
  const separator = document.createElement('span');
  separator.setAttribute('aria-hidden', 'true');
  separator.textContent = '/';
  breadcrumbs.append(homeLink, separator);
  const current = document.createElement('span');
  current.setAttribute('aria-current', 'page');
  current.textContent = pageTitle;
  breadcrumbs.append(current);

  const eyebrow = document.createElement('p');
  eyebrow.className = 'berara-native-policy__eyebrow';
  eyebrow.textContent = document.body.dataset.beraraPolicyEyebrow || 'Legal information';

  hero.append(breadcrumbs, eyebrow, title);
  container.prepend(hero);

  const layout = document.createElement('div');
  layout.className = 'berara-native-policy__layout';
  const headings = [...body.querySelectorAll('h2')];

  if (headings.length) {
    const aside = document.createElement('aside');
    aside.className = 'berara-native-policy__sidebar';

    const desktopToc = document.createElement('div');
    desktopToc.className = 'berara-native-policy__toc-desktop';
    const desktopTitle = document.createElement('p');
    desktopTitle.className = 'berara-native-policy__toc-title';
    desktopTitle.textContent = tocLabel;
    desktopToc.append(desktopTitle);
    desktopToc.append(makePolicyLinks(headings));

    const mobileToc = document.createElement('details');
    mobileToc.className = 'berara-native-policy__toc-mobile';
    const mobileSummary = document.createElement('summary');
    const mobileLabel = document.createElement('span');
    mobileLabel.textContent = tocLabel;
    const mobileIcon = document.createElement('span');
    mobileIcon.setAttribute('aria-hidden', 'true');
    mobileIcon.textContent = '+';
    mobileSummary.append(mobileLabel, mobileIcon);
    mobileToc.append(mobileSummary);
    mobileToc.append(makePolicyLinks(headings));

    aside.append(desktopToc, mobileToc);
    layout.append(aside);
  }

  layout.append(body);
  container.append(layout);
};

initialiseBeraraPolicy();
